import { FaHeart, FaHeartBroken } from "react-icons/fa";

interface LivesMeterProps {
  lives: number;
  startingLives: number;
}

export default function LivesMeter({ lives, startingLives }: LivesMeterProps) {
  return (
    <div className="justify-center items-center flex gap-2 mx-4 h-10 bg-deep-purple-700 p-2 rounded-md">
      {Array(lives).fill(<FaHeart className="text-red-500" />)}
      {Array(startingLives - lives).fill(
        <FaHeartBroken className="text-gray-500" />
      )}
    </div>
  );
}
